define('TescoMobile_Customer/js/view/account/dashboard/single-sub-perks',['uiComponent', 'jquery', 'Magento_Ui/js/modal/modal'], function (Component, $, modal) {
  "use strict";

  return Component.extend({
    modalContentId: null,
    modalId: null,
    initialize: function () {
      this._super();
      this.initModal(this.modalContentId);
    },
    openModal: function () {
      $(this.modalContentId).modal('openModal');
    },
    initModal: function (id) {
      var options = {
        type: 'slide',
        modalClass: 'single-sub-modal',
        title: '',
        buttons: []
      };
      this.modalId = modal(options, $(id));
    }
  });
});

